export const auctionReducer = (
    state = {
        singleAuction: {},
        readSingleAuctionLoading: false,
        allAuctions: [],
        readAuctionsLoading: false,
        auctionAnalytics: {},
        generateReportLoading: false,
        auctionAnalyticsLoading: false,
        reportViewPdfLoading: false,
        bidsPermissions: [],
        reportPdfUrl: null,
        singleOfferData: {},
        offerDetailLoading: false,
        publishLoading: false,
    },
    action
) => {
    switch (action.type) {
        case "PUBLISHING_AUCTION":
            return { ...state, publishLoading: true };
        case "PUBLISHED_AUCTION":
            return { ...state, publishLoading: false };
        case "CANNOT_PUBLISH_AUCTION":
            return { ...state, publishLoading: false };

        case "READING_SINGLE_AUCTION":
            return {
                ...state,
                readSingleAuctionLoading: true,
            };


        case "GOT_SINGLE_AUCTION":
            return {
                ...state,
                readSingleAuctionLoading: false,
                singleAuction: action.payload
            };

        case "CANNOT_GET_SINGLE_AUCTION":
            return {
                ...state,
                readSingleAuctionLoading: false,
            };




        case "GETTING_BIDS_PERMISSION":
            return {
                ...state,
                readAuctionsLoading: true,
            };

        case "GOT_BIDS_PERMISSIONS":
            return {
                ...state,
                readAuctionsLoading: false,
                bidsPermissions: action.payload
            };

        case "CANNOT_GET_BIDS_PERMISSIONS":
            return {
                ...state,
                readAuctionsLoading: false,
            };






        case "GETTING_ALL_AUCTIONS":
            return {
                ...state,
                readAuctionsLoading: true,
            };

        case "GOT_ALL_AUCTIONS":
            return {
                ...state,
                readAuctionsLoading: false,
                allAuctions: action.payload
            };

        case "CANNOT_GET_ALL_AUCTIONS":
            return {
                ...state,
                readAuctionsLoading: false,
            };

        case "GETTING_ALL_ANALYTICS":
            return {
                ...state,
                auctionAnalyticsLoading: true,
            };

        case "GOT_ALL_ANALYTICS":
            return {
                ...state,
                auctionAnalyticsLoading: false,
                auctionAnalytics: action.payload
            };

        case "CANNOT_GET_ALL_ANALYTICS":
            return {
                ...state,
                auctionAnalyticsLoading: false,
            };

        case "GENERATE_AUCTION_REPORT_LOADING":
            return { ...state, generateReportLoading: true };
        case "GENERATE_AUCTION_REPORT_SUCCESS":
            return { ...state, generateReportLoading: false };
        case "GENERATE_AUCTION_REPORT_FAILED":
            return { ...state, generateReportLoading: false };



        case "GET_AUCTION_REPORT_LOADING":
            return { ...state, reportViewPdfLoading: true };
        case "GET_AUCTION_REPORT_SUCCESS":
            return {
                ...state,
                reportPdfUrl: action.payload,
                reportViewPdfLoading: false,
            };
        case "GET_AUCTION_REPORT_FAILED":
            return { ...state, reportViewPdfLoading: false, reportPdfUrl: null };


        case "GETTING_OFFER_DETAILS":
            return { ...state, offerDetailLoading: true };
        case "GOT_OFFER_DETAILS":
            return { ...state, singleOfferData: action.payload, offerDetailLoading: false };
        case "CANNOT_GET_OFFER_DETAILS":
            return { ...state, offerDetailLoading: false };

        default:
            return state;
    }
};



const initailState = {
    liveAuctionListData: {},
    liveBiddingHistry: {},
    auctionLoading: false,
    liveRoomSingleAuctionLoading: false,
    liveRoomSingleAuctionData: {},
    biderActivity: {},
    minimumBidUpdateLoading: false,
    startingPriceLoading: false,
    auctionTimeLoading: false
};

export function liveAuctionListReducer(state = initailState, { type, payload }) {
    switch (type) {
        case "LIVE_AUCTION_LIST_LOADING":
            return { ...state, auctionLoading: true };
        case "LIVE_AUCTION_LIST_SUCCESS":
            return { ...state, auctionLoading: false, liveAuctionListData: payload };
        case "LIVE_AUCTION_LIST_FAILED":
            return { ...state, auctionLoading: false, liveAuctionListData: {} };
        case "LIVE_AUCTION_HISTORY_SUCCESS":
            return { ...state, auctionLoading: false, liveBiddingHistry: payload };
        case "SINGLE_AUCTION_LIVE_LOADING":
            return { ...state, liveRoomSingleAuctionLoading: true, };
        case "SINGLE_AUCTION_LIVE_SUCCESS":
            return { ...state, liveRoomSingleAuctionLoading: false, liveRoomSingleAuctionData: payload };
        case "SINGLE_AUCTION_LIVE_FAILED":
            return { ...state, liveRoomSingleAuctionLoading: false, };
        case "SINGLE_AUCTION_LIVE_ACTIVITY_SUCCESS":
            return { ...state, liveRoomSingleAuctionLoading: false, biderActivity: payload };
        case "SINGLE_AUCTION_MINIMUMBID_LOADING":
            return { ...state, minimumBidUpdateLoading: true };
        case "SINGLE_AUCTION_MINIMUMBID_SUCCESS":
            return { ...state, minimumBidUpdateLoading: false };
        case "SINGLE_AUCTION_MINIMUMBID_FAILED":
            return { ...state, minimumBidUpdateLoading: false };
        case "SINGLE_AUCTION_STARTINGPRICE_LOADING":
            return { ...state, startingPriceLoading: true };
        case "SINGLE_AUCTION_STARTINGPRICE_SUCCESS":
            return { ...state, startingPriceLoading: false };
        case "SINGLE_AUCTION_STARTINGPRICE_FAILED":
            return { ...state, startingPriceLoading: false };
        case "SINGLE_AUCTION_EXTEND_TIME_LOADING":
            return { ...state, auctionTimeLoading: true };
        case "SINGLE_AUCTION_EXTEND_TIME_SUCCESS":
            return { ...state, auctionTimeLoading: false };
        case "SINGLE_AUCTION_EXTEND_TIME_FAILED":
            return { ...state, auctionTimeLoading: false };

        default:
            return state;
    }
}